// Default booking steps for different languages
export const DEFAULT_BOOKING_STEPS = {
  en: [
    { 
      id: 1, 
      title: "Customer makes booking online", 
      description: "Browse service and select your preferred time and book online" 
    },
    { 
      id: 2, 
      title: "Staff will call customer to confirm details of booking", 
      description: "Our team will contact you to verify appointment details" 
    }
  ],
  zh: [
    { 
      id: 1, 
      title: "客户在线预约", 
      description: "浏览服务并选择您的首选时间在线预约" 
    },
    { 
      id: 2, 
      title: "工作人员将致电客户确认预约详情", 
      description: "我们的团队将联系您以确认预约详情" 
    }
  ]
};